import React from "react";

const DisclaimerText = ({ isCDTT }) => {
  return (
    <small className="text-dark fs-px-14">
      By submitting your contact information, you agree to be contacted by your
      selected dealership by text message or phone call at the telephone number
      you provide for the purpose of communicating with you about the
      information you have requested or to send other marketing messages. You
      agree that texts or calls may be sent using an automatic dialing system or
      other automated technology and/or a pre-recorded/artificial voice message.
      You understand that your consent is not a condition to purchase or obtain
      any good or service. You may also be contacted by email. In addition, by
      submitting your contact information, you agree to the{" "}
      {isCDTT ? (
        <>
          <a
            href="https://www.hearst.com/-/us-magazines-terms-of-use"
            target="_blank"
            className="text-primary"
          >
            Terms of Use
          </a>{" "}
          (including the{" "}
          <a
            href="https://www.hearst.com/-/hearst-com-terms-of-use#dispute"
            target="_blank"
            className="text-primary"
          >
            dispute resolution procedures
          </a>
          ), and that you have reviewed the{" "}
          <a
            href="https://www.hearst.com/-/us-magazines-privacy-notice"
            target="_blank"
            className="text-primary"
          >
            Privacy Notice
          </a>
          .
        </>
      ) : (
        "Terms of Use (including the dispute resolution procedures) and that you have reviewed the Privacy Notice."
      )}
    </small>
  );
};

export default DisclaimerText;
